<template>
    <div ref="mapview" class="map-view">
        <ProviderList
            v-if="!isMobile && (sidebarVisible || minimalUi)"
            v-slot="{ items, expandAll }"
            class="w-72"
            :slim="true"
            :list-heading="listHeading"
        >
            <ProviderListItem
                v-for="(item, i) in items"
                :id="`marker-${item.id}`"
                :key="item.id"
                :item="item"
                :expand="expandAll"
                :expand-initialised="minimalUi && i == 0"
                :active-marker="activeMarker"
                :hide-website="hideWebsiteInListings"
                @set-as-active="setActiveMarker(item)"
            />

            <p v-if="!items.length" id="map-no-results" class="py-10 text-center text-blue-500">
                No results in this location. Use the - button on the map to find your closest
                provider
            </p>
        </ProviderList>

        <GeoSearch
            ref="geosearch"
            class="flex-1"
            :active-marker="activeMarker"
            :map-defaults="mapDefaults"
            :use-geo-location="useGeoLocation"
            @set-active-marker="setActiveMarker($event)"
            @report-map="reportMapThrottle"
        />
    </div>
</template>

<script>
import { debounce } from 'lodash';
import GeoSearch from './GeoSearch';
import ProviderList from './ProviderList';
import ProviderListItem from './ProviderListItem';

export default {
    components: {
        ProviderList,
        ProviderListItem,
        GeoSearch
    },

    props: {
        mapDefaults: {
            type: Object,
            default: null
        },
        useGeoLocation: {
            type: Boolean,
            default: true
        },
        minimalUi: {
            type: Boolean,
            default: false
        },
        hideWebsiteInListings: {
            type: Boolean,
            default: false
        },
        listHeading: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            sidebarVisible: false,
            activeMarker: null
        };
    },

    computed: {
        isMobile() {
            return this.$mq === 'mobile';
        }
    },

    methods: {
        // Pass search results down to map
        adjustMap(geometry) {
            this.showSidebar();
            this.$refs.geosearch.adjustMap(geometry);
        },

        reportMapThrottle: debounce(function (value) {
            this.$emit('report-map', value);
        }, 1000),

        showSidebar() {
            this.sidebarVisible = true;
        },

        setActiveMarker(marker) {
            this.showSidebar();
            if (!marker || (this.activeMarker && this.activeMarker.id === marker.id)) {
                this.activeMarker = null;
            } else {
                this.activeMarker = marker;

                const scroll = setInterval(() => {
                    const infobox = this.$refs.mapview.querySelector(`#marker-${marker.id}`);
                    if (infobox) {
                        infobox.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest',
                            inline: 'start'
                        });
                    }
                }, 500);
                setTimeout(() => clearInterval(scroll), 2500);
            }
        }
    }
};
</script>
<style scoped>
.map-view {
    @apply flex mx-auto;
    max-width: 1112px;
    min-height: 75vh;
    max-height: 700px;
    height: 90vh;
}

.reduced-height .map-view {
    min-height: 400px;
    max-height: 600px;
    height: 55vh;
}

::v-deep button:focus {
    outline: none;
}
</style>
